<template>
  <div class="modal-aside-header">
    <slot />
    <span class="modal-aside-header__close" @click="modalAside.hide">
      <svg><use xlink:href="#svg-close"></use></svg>
    </span>
  </div>
</template>

<script lang="ts" setup>
import useModalAside from '@use/useModalAside/useModalAside';

const modalAside = useModalAside();
</script>

<style lang="scss" scoped>
.modal-aside-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  background-color: #b8d9ec;
  margin: -16px -16px 16px;
  padding: 0 16px;
  @include point-md {
    height: unset;
    background-color: transparent;
    padding: 0;
    margin: 0;
  }
  &__close {
    cursor: pointer;
    &:hover {
      svg {
        fill: var(--color-red);
      }
    }
    svg {
      display: block;
      width: 16px;
      height: 16px;
      transition: 0.2s linear fill;
      fill: var(--background-black);
      @include point-md {
        width: 24px;
        height: 24px;
      }
    }
  }
  :deep(& > *) {
    margin-bottom: 0;
  }
  :deep(.def-title) {
    margin-bottom: 0;
    transform: translateY(2px);
  }
}
</style>
